import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useQuery} from "@apollo/client";
import {getMenuItem} from "../menus/ClientMenuQueries";
import {tableImageTag} from "../../../helpers/Api";
import {Col, Container, Row} from "react-bootstrap";
import PageTitle from "../../../layout/PageTitle";
import {BackButton} from "../../../helpers/ButtonHelper";
import Loader from "../../shared/Loader";

const ClientPlateDetails = () => {
  const params = useParams();
  const { loading, data } = useQuery(getMenuItem, { variables: { id: params.id } })
  const item = !loading && data.menuItem
  const plate = item && item.plate
  const navigate = useNavigate()

  if (loading) return <Loader />;
  
  return (
    <>
      <Container>
        <PageTitle title={`${item.menu.name} - Ziua ${item.day} - ${item.category.name}`} buttons={
          <BackButton to={`/my_menus/${item.menu.id}`} onClick={() => navigate(-1)} showText={true}
                      text='Inapoi la lista' />
        } />
        <Row className="mb-2">
          <div className="col-md-12 mb-3">
            <Row>
              <div className="col-md-auto col-sm-12">
                {tableImageTag(plate, {
                  width: 250,
                  height: 250,
                  className: 'w-100 object-fit-contain border rounded'
                })}
              </div>
              <Col>
                <div className="fs-4 fw-bold">{plate.name}</div>
                <div className="mt-2 mb-4 d-flex justify-content-between">
                  <span className="badge fs-5 p-2 fw-bold rounded rounded-3 border border-branding border-2 text-black">
                    Ziua {item.day}
                  </span>
                  <span className="badge bg-branding ms-2 fs-5 p-2">
                    {item.category.name}
                    {item.category.time && <em className='fs-6'> ({item.category.time})</em>}
                  </span>
                </div>
                <div className="form-control fs-5">{plate.details}</div>
              </Col>
            </Row>
          </div>
          <Col className="col-lg-4">
            <div id="ingredients">
              <ul className="list-group">
                <li className="list-group-item bg-branding text-light"><strong>Ingrediente</strong></li>
                {plate.plateIngredients.map(({ ingredient, qty, unit, qtyInfo }, index) =>
                  <li key={index}
                      className="list-group-item">{ingredient.name} - {qty}{unit.name} {qtyInfo && `(${qtyInfo})`} </li>
                )}
              </ul>
            </div>
          </Col>
        </Row>

        {/*<Row>*/}
        {/*  <hr/>*/}
        {/*</Row>*/}
      </Container>
      {/*{!loading &&*/}
      {/*  // <ClientPlatesList menu={plate}></ClientPlatesList>*/}
      {/*}*/}
      <div className='mb-3'></div>
    </>
  )
};

export default ClientPlateDetails;
